import Vue from "vue";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";

Vue.component(FeatherIcon.name, FeatherIcon);

import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import "bootstrap/scss/bootstrap.scss";
Vue.component("vue-typeahead-bootstrap", VueTypeaheadBootstrap);
